module.exports = __webpack_public_path__ + "img/f79b0d9.png";